module.exports = __webpack_public_path__ + "img/google-play-badge.c6bc8e0c.svg";